<template>
  <div class="results-history-list__container width-responsiveness">
    <Spinner v-if="resultsHistoryLoadingStatus" />
    <template v-else>
      <div class="results-history-list__header">
        <h3>LISTA DE PACIENTES</h3>
      </div>
      <template v-if="resultsHistoryListData.historicalReport && resultsHistoryListData.historicalReport.length > 0">
        <table class="apoio-datatable white-head">
          <colgroup>
            <col class="column-date">
            <col class="column-os">
            <col class="column-patient-name">
            <col class="column-export">
          </colgroup>
          <thead>
            <tr>
              <th
                class="column-date"
                title="Data de Cadastro"
              >
                Data
              </th>
              <th
                class="column-os-alvaro"
                title="OS Alvaro"
              >
                OS Alvaro
              </th>
              <th
                class="column-patient-name"
                title="Nome Completo"
              >
                Paciente
              </th>
              <th class="column-export" />
            </tr>
          </thead>
        </table>

        <table class="apoio-datatable apoio-datatable-alt">
          <colgroup>
            <col class="column-date">
            <col class="column-os">
            <col class="column-patient-name">
            <col class="column-export">
          </colgroup>
          <tbody
            v-for="(result, index) in resultsHistoryListData.historicalReport"
            :key="index"
          >
            <tr class="apoio-datatable__line apoio-datatable-alt">
              <td class="column-date">
                <span :title="formatedDate(result.date_order)">
                  {{ formatedDate(result.date_order) }}
                </span>
              </td>
              <td>
                <span :title="result.id_order">{{ result.id_order }}</span>
              </td>
              <td>
                <span :title="result.patient_name">
                  {{ result.patient_name }}
                </span>
              </td>
              <td class="column-export">
                <button
                  class="btn btn-primary btn-inline"
                  @click.stop="exportResultHistoryInPDF(result)"
                >
                  <md-tooltip
                    md-delay="400"
                    md-direction="left"
                  >
                    Exportar selecionados em PDF
                  </md-tooltip>
                  <md-icon
                    md-src="/static/images/icon-pdf-doc.svg"
                    class="icon-pdf"
                  />
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div>
          <Pagination
            :current-page="currentPage"
            :total-pages="totalPages"
            @page-change="changePage"
          />
        </div>
      </template>
      <div
        v-else
        class="empty-search"
      >
        <md-icon md-src="/static/images/icon-no-tubes-found.svg" />
        <p>Não foi encontrado nenhum resultado.</p>
      </div>
    </template>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import Spinner from '@/components/common/Spinner'
import { mapGetters, mapActions } from 'vuex'
import Moment from 'moment'

export default {
  components: {
    Pagination,
    Spinner
  },
  props: {
    resultsHistoryListData: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      selectedItems: []
    }
  },
  computed: {
    ...mapGetters(['resultsHistoryFilters', 'resultsHistoryLoadingStatus']),
    currentPage() {
      return this.resultsHistoryListData.page
    },
    totalPages() {
      return this.resultsHistoryListData.totalPages
    }
  },
  methods: {
    ...mapActions(['getResultsHistoryFilter', 'getServiceResultsHistory', 'exportResultHistoryInPDF']),
    changePage(page) {
      let newFilter = this.resultsHistoryFilters
      newFilter['page'] = page
      this.getResultsHistoryFilter(newFilter)
      this.getServiceResultsHistory()
    },
    formatedDate(date) {
      return Moment(date, 'DD-MM-YYYY HH:mm:ss').format('DD/MM/YYYY')
    }
  }
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/mixins';

.results-history-list {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 24px;
    font-family: 'Exo 2', sans-serif !important;

    h3 {
      color: #7a7a7a;
      font-weight: 500;
      font-size: 18px;
    }

    .export {
      padding: 0 15px;
      border: 1px solid #e8eaed;
      border-radius: 5px;
      background: #7f1a54;
      font-size: 14px;
      text-transform: uppercase;
      font-weight: 600;
      height: 40px;
      cursor: pointer;
      font-family: 'Exo 2', sans-serif !important;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      i.md-icon {
        margin-left: 8px;
        width: 18px;
        min-width: 18px;
      }
    }

    .exams-qtd {
      width: 20px;
      height: 20px;
      background: #fff;
      font-size: 12px;
      color: #801a54;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #801a54;
      border-radius: 50%;
      position: absolute;
      left: -8px;
      top: -8px;
    }
  }

  &__container {
    margin-top: 20px;
    margin-bottom: 50px;
    font-family: 'Exo 2', sans-serif !important;

    .apoio-datatable {
      &__line {
        height: 56px;
        cursor: pointer;

        &.--bold {
          font-weight: 700;
        }

        a {
          color: #797979;
        }
      }

      th {
        letter-spacing: 1px;
        text-transform: uppercase;
      }
    }

    .column-date {
      width: 180px;
      padding-left: 24px;
    }

    .column-os {
      width: 20%;
    }

    .column-export {
      text-align: center;
      width: 200px;
    }

    .apoio-datatable {
      margin-top: 0;
    }

    .tooltip-size {
      width: 20px;
    }

    .btn-inline {
      min-width: 50px;

      i {
        width: 20px;
        height: 20px;
        min-width: 20px;

        path {
          fill: white;
        }
      }

      .traceability {
        width: 26px;
        height: 26px;
        margin-top: 3px;
      }
    }

    .loader {
      margin: 80px auto;
    }

    .empty-search {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 100px;

      i {
        width: 120px;
        height: 120px;
      }

      p {
        font-size: 18px;
        margin-top: 26px;
      }
    }
  }
}
</style>
